<template>
  <div>
    <div class="pt-4">
      <ComplementaryProductCart
        v-if="complementaryBaseProduct"
        :product="complementaryBaseProduct"
        :is-always-checked="true"
      />
      <div class="text-center p-4">
        <span class="iconify svg--accordion-open text-4xl" />
      </div>
      <div class="grid lg:grid-cols-2 gap-4">
        <ComplementaryProductCart
          v-for="product in complementaryProducts"
          :key="product.sku || product.id"
          :product="product"
          :is-selected="product.sku ? selectedProducts.includes(product.sku) : false"
          @product-selection-changed="onProductSelectionChanged($event)"
          @product-clicked="onProductClicked(product.sku)"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">


import { getLineItemFromSku } from '~~/helpers/cart/getLineItemFromSku';
import type { ProductVariantExtended } from '~~/types/product/ProductVariantExtended';

export default defineComponent({
  name: 'ComplementaryProductsInCart',

  setup() {

    const {
      complementaryProducts,
      complementaryBaseProduct,
      selectedProducts,
      toggleSelectedProduct,
    } = useComplementaryProductsStore();
    const { cart, addItem, updateQuantity } = useCartExtended();
    const { callAddToCart, callClickBundleItem, callViewEvent } = useBundleBuilderEvents();

    const processingSkus = ref(new Set<string>());

    const onProductSelectionChanged = async (event: {
      sku: string;
      product: ProductVariantExtended;
      currentlySelected: boolean;
    }) => {

      const { sku, product, currentlySelected } = event;

      if (processingSkus.value.has(sku)) {

        return;

      }

      processingSkus.value.add(sku);

      try {

        toggleSelectedProduct(sku);

        if (!currentlySelected) {

          await addItem({
            product,
            quantity: 1,
          });
          callAddToCart(sku);

        } else {

          const lineItem = getLineItemFromSku(cart.value, sku);

          if (lineItem) {

            await updateQuantity(lineItem, lineItem.quantity - 1);

          }

        }

      } finally {

        processingSkus.value.delete(sku);

      }

    };

    const onProductClicked = (sku: Maybe<string>) => {

      if (sku) {

        callClickBundleItem(sku);

      }

    };

    onMounted(() => {

      if (complementaryBaseProduct.value?.sku) {

        callViewEvent(complementaryBaseProduct.value.sku);

      }

    });

    return {
      onProductSelectionChanged,
      onProductClicked,
      complementaryBaseProduct,
      complementaryProducts,
      selectedProducts,
    };

  },
});

</script>
